import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from "react";
import classNames from "classnames";
import { Icon } from "../../components/Icon/Icon";
import Arrow from "../../icons/arrow.svg";
import Minus from "../../icons/minus.svg";
import Plus from "../../icons/plus.svg";
import styles from "./Card.module.scss";
const getIcon = (isCollapsed, iconVariant) => {
    if (iconVariant === "plus") {
        return _jsx(Icon, { component: isCollapsed ? Plus : Minus, width: "14px", height: "14px" });
    }
    if (iconVariant === "arrow") {
        return _jsx(Icon, { component: Arrow, rotate: isCollapsed ? 180 : 0, width: "14px", height: "14px" });
    }
};
const getContent = (isCollapsible, children, title, classNameContent) => {
    return (_jsx("div", { className: classNames(classNameContent, styles.content, {
            [styles.collapsible]: isCollapsible,
            [styles.withoutTitle]: !title,
        }), children: children }));
};
/**
 * @deprecated use Card from @jti/ui instead
 */
export const DEPRECATED_Card = ({ title, titleOpen, children, variant = "variant1", iconVariant = "plus", pending, disabled, isCollapsible = false, collapsed = false, onToggle, classNameContent, nonCollapsibleContent, id, className, classNameTitle, titleDataTestId, ...restProps }) => {
    const [isCardCollapsed, setIsCardCollapsed] = useState(collapsed);
    const toggle = useCallback(() => (onToggle ? onToggle() : setIsCardCollapsed(!isCardCollapsed)), [onToggle, setIsCardCollapsed, isCardCollapsed]);
    const isCollapsed = onToggle ? collapsed : isCardCollapsed;
    const collapsibleStyle = isCollapsible ? styles.collapsible : "";
    const handleClick = isCollapsible ? toggle : undefined;
    const titleText = isCollapsed || !titleOpen ? title : titleOpen;
    return (_jsxs("div", { ...restProps, "data-variant": `card-${variant}`, className: classNames(className, styles.container, styles["variant-" + variant], {
            [styles.pending]: pending,
            [styles.disabled]: disabled,
        }), id: id, children: [title ? (_jsxs("div", { className: classNames(styles.title, collapsibleStyle, classNameTitle), onClick: handleClick, "data-testid": titleDataTestId || "", children: [_jsx("h2", { children: titleText }), isCollapsible && getIcon(isCollapsed, iconVariant)] })) : null, !isCollapsed && getContent(isCollapsible, children, title, classNameContent), nonCollapsibleContent && getContent(false, nonCollapsibleContent, "", classNameContent)] }));
};
//# sourceMappingURL=DEPRECATED_Card.js.map